import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import Disabled from '../../../assets/icons/disabled.svg';
import { useStyles } from './ScoreDeleteButton.styles';

interface ScoreDeleteButtonProps extends ButtonProps {
  isDisabled: boolean;
  onClick: () => void;
}

const ScoreDeleteButton: React.FC<ScoreDeleteButtonProps> = (props) => {
  const classes = useStyles();

  if (props.isDisabled) {
    return (
      <Button
        style={{ width: '105px' }}
        color="inherit"
        variant="contained"
        className={classes.disableButton}
        startIcon={<img src={Disabled} alt="ikona przycisk nieaktywny" />}
      >
        WYCZYŚĆ
      </Button>
    );
  } else {
    return (
      <Button
        style={{ width: '85px' }}
        variant="contained"
        color="inherit"
        className={classes.activeButton}
        onClick={props.onClick}
      >
        WYCZYŚĆ
      </Button>
    );
  }
};

export default ScoreDeleteButton;
